// Product types ids
export default { ELCANO_MASTER: 15 };



// WEBPACK FOOTER //
// ./src/utils/productTypesIds.js